/** @typedef {"increasing" | "decreasing" | "stable"} ForecastTrend */

/**
 * @typedef {Object} ForecastResult
 * @property {string} itemName
 * @property {string} branchName
 * @property {number|null} currentStock
 * @property {number} totalSales
 * @property {number} avgMonthlySales
 * @property {number} avgDailySales
 * @property {number} last3MonthsAvg
 * @property {number|null} sameMonthPrevYearSales
 * @property {number|null} growthPercent
 * @property {number} forecast15Days
 * @property {number} safetyStock
 * @property {number} recommendedQty
 * @property {number|null} purchaseQty
 * @property {ForecastTrend} trend
 * @property {Record<string, number>} monthlySales — monthKey → qty
 * @property {number} monthsOfHistory
 */

export const TREND_LABELS = {
  increasing: "📈 Increasing",
  decreasing: "📉 Decreasing",
  stable: "➡ Stable",
};

export function emptyForecastResult(itemName, branchName = "", currentStock = null) {
  return {
    itemName,
    branchName: branchName || "All",
    currentStock,
    totalSales: 0,
    avgMonthlySales: 0,
    avgDailySales: 0,
    last3MonthsAvg: 0,
    sameMonthPrevYearSales: null,
    growthPercent: null,
    forecast15Days: 0,
    safetyStock: 0,
    recommendedQty: 0,
    purchaseQty: currentStock != null ? 0 : null,
    trend: "stable",
    monthlySales: {},
    monthsOfHistory: 0,
  };
}
